module.exports = __webpack_public_path__ + "static/media/dance-drama.bf71c6af.svg";